module.exports = __webpack_public_path__ + "img/logo-preto-amorsaude.99657fa9.svg";